import { z } from "zod";

export const matchPhaseSchema = z.enum([
  "pre_match",
  "first_half",
  "halftime",
  "second_half",
  "extra_first",
  "extra_break",
  "extra_second",
  "penalties",
  "full_time",
]);
export type MatchPhase = z.infer<typeof matchPhaseSchema>;

export const statsFieldsSchema = z.object({
  passes: z.number().int().nonnegative().default(0),
  passes_completed: z.number().int().nonnegative().default(0),
  passes_incompleted: z.number().int().nonnegative().default(0),
  passes_accuracy: z.number().min(0).max(100).default(0),
  ball_control: z.number().min(0).max(100).default(0),
  tackles: z.number().int().nonnegative().default(0),
  shots: z.number().int().nonnegative().default(0),
  shots_on_target: z.number().int().nonnegative().default(0),
  shots_off_target: z.number().int().nonnegative().default(0),
  shots_accuracy: z.number().min(0).max(100).default(0),
  key_passes: z.number().int().nonnegative().default(0),
  saves: z.number().int().nonnegative().default(0),
  corners: z.number().int().nonnegative().default(0),
  touches: z.number().int().nonnegative().default(0),
  fouls: z.number().int().nonnegative().default(0),
  // xG — not an integer (SKORE shows it as 0.9 / 1.58).
  xg: z.number().nonnegative().max(99).default(0),
  offsides: z.number().int().nonnegative().default(0),
  cards_yellow: z.number().int().nonnegative().default(0),
  cards_red: z.number().int().nonnegative().default(0),
  /** Derived: red cards that left the team a player short (the player was on
   *  the pitch). The scoreboard's red markers show this, not `cards_red`. */
  sent_off: z.number().int().nonnegative().default(0),
});
export type StatsFields = z.infer<typeof statsFieldsSchema>;

export const matchStateSchema = z.object({
  matchId: z.string(),
  homeScore: z.number().int().nonnegative(),
  awayScore: z.number().int().nonnegative(),
  minute: z.number().int().min(0).max(130),
  second: z.number().int().min(0).max(59),
  phase: matchPhaseSchema,
  additionalTime: z.number().int().nonnegative().default(0),
  running: z.boolean().default(false),
  homeStats: statsFieldsSchema,
  awayStats: statsFieldsSchema,
  updatedAt: z.string().datetime(),
});
export type MatchState = z.infer<typeof matchStateSchema>;
